import React from 'react';

const WelcomePanelWithoutBots = (props) => (
  <div style={{ width: '100%' }}>
    <h2>
      <span>
        {`Bem vindo(a) ${props.name}. `}
        <span className="text-danger">
          <br />
          Não foi encontrado nenhum chatbot para você realizar a curadoria.
        </span>
      </span>
    </h2>
    <h3>
      { `Isso acontece porque você não faz parte de
      nenhuma equipe de manutenção de chatbot. `}
      <br />
      {'Acesse a '}
      <a
        target="_blank"
        rel="noreferrer"
        href={`https://${window.location.hostname}/docs/criando/criando/`}
      >
        Documentação do Serprobots
      </a>
      {` para entender como
      chatbots podem ser criados e como você pode realizar a curadoria. `}
    </h3>
  </div>
);

export default WelcomePanelWithoutBots;
